import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TextPageContentBlock = ({ children, className, subtitle, }) => {
    return (_jsxs("div", Object.assign({ className: `pb-3 ${className ? className : ""}` }, { children: [subtitle && _jsx("h2", Object.assign({ className: "mb-4 mt-5 text-primary" }, { children: subtitle })), _jsx("div", Object.assign({ className: "text-primary" }, { children: children }))] })));
};
export default TextPageContentBlock;
